import { addTraits } from 'src/api';

export const getLicenses = state => addTraits(state.licenses.licenses);
